if (!customElements.get('cart-shot-glass-nudge')) {
  customElements.define(
    'cart-shot-glass-nudge',
    class CartShotGlassNudge extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-add-shot-glass]');
        if (this.button) {
          this.button.addEventListener('click', this.onAdd.bind(this));
        }
      }

      async onAdd(event) {
        event.preventDefault();
        if (this.button.disabled) return;

        const variantId = this.button.dataset.variantId;
        if (!variantId) return;

        this.button.disabled = true;
        this.classList.add('cart-shot-glass-nudge--loading');

        const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
        const inDrawerContext = !!this.closest('cart-drawer');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const sectionsToFetch = [];
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          drawer.getSectionsToRender().forEach((section) => sectionsToFetch.push(section.id));
        } else {
          sectionsToFetch.push('cart-icon-bubble');
        }
        formData.append('sections', sectionsToFetch.join(','));
        formData.append('sections_url', window.location.pathname);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            console.error('[shot-glass-nudge] Could not add free shot glass:', data.description || data.message);
            return;
          }

          if (inDrawerContext && drawer && typeof drawer.renderContents === 'function') {
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else if (data.sections && data.sections['cart-icon-bubble']) {
            const iconBubble = document.getElementById('cart-icon-bubble');
            if (iconBubble) {
              const parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              const inner = parsed.querySelector('.shopify-section');
              if (inner) iconBubble.innerHTML = inner.innerHTML;
            }
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-shot-glass-nudge',
            productVariantId: variantId,
            cartData: data,
          });
        } catch (err) {
          console.error('[shot-glass-nudge] Error adding free shot glass:', err);
        } finally {
          this.button.disabled = false;
          this.classList.remove('cart-shot-glass-nudge--loading');
        }
      }
    }
  );
}
